<h1 class="title">
  {{ 'static-content-online-booking-benefit.text.title-1' | translate }}
  <span class="highlight-color">
    {{ 'static-content-online-booking-benefit.text.title-2' | translate }}
  </span>
</h1>

<div>
  {{ 'static-content-online-booking-benefit.text.description' | translate }}
</div>

<lib-spacer [height]="40"></lib-spacer>

<div style="display: flex; justify-content: center; width: 100%">
  <div class="container">
    <div class="item" style="--accent-color: #d3302c">
      <ng-container
        [ngTemplateOutlet]="featureTemplate"
        [ngTemplateOutletContext]="{
          icon: 'location_on',
          title: 'static-content-online-booking-benefit.text.any-where-title',
          description:
            'static-content-online-booking-benefit.text.any-where-description'
        }"
      ></ng-container>
    </div>
    <div class="item" style="--accent-color: #f3a22d">
      <ng-container
        [ngTemplateOutlet]="featureTemplate"
        [ngTemplateOutletContext]="{
          icon: 'schedule',
          title: 'static-content-online-booking-benefit.text.any-time-title',
          description:
            'static-content-online-booking-benefit.text.any-time-description'
        }"
      ></ng-container>
    </div>
    <div class="item" style="--accent-color: #495460">
      <ng-container
        [ngTemplateOutlet]="featureTemplate"
        [ngTemplateOutletContext]="{
          icon: 'redeem',
          title: 'static-content-online-booking-benefit.text.discount-title',
          description:
            'static-content-online-booking-benefit.text.discount-description'
        }"
      ></ng-container>
    </div>
  </div>
</div>

<ng-template
  #featureTemplate
  let-icon="icon"
  let-title="title"
  let-description="description"
>
  <mat-icon>{{ icon }}</mat-icon>
  <div class="core-feature-title" [innerHTML]="title | translate"></div>
  <div class="core-feature-content">
    {{ description | translate }}
  </div>
</ng-template>
